// Shadowbox namespace.
Foundation.Shadowbox = {};

/**
 * On open Shadowbox event handler.
 */
Foundation.Shadowbox.onOpen = function () {
    var cb = document.getElementById("sb-nav-close"); 
    var tb = document.getElementById("sb-title"); 
    if (tb) tb.appendChild(cb);
};

/**
 * Default options for Shadowbox.
 * @const
 */
Foundation.Shadowbox.defaultOptions = {
    "onOpen": Foundation.Shadowbox.onOpen,
    "animate": true,
    "animateFade": true,
    "animSequence": "sync",
    "autoDimensions": false,
    "modal": false,
    "showOverlay": true,
    "overlayOpacity": 0.8,
    "handleOversize": "none"
};

/**
 * Initialize the Shadowbox CSS and JavaScript. Must be called
 * while the page is still loading, and after the shadowbox.js file
 * has been included with dnLoadScript() or Foundation.Script.
 * @param {Object} options Overrides the default options for Foundation.
 */
Foundation.Shadowbox.init = function (options) {
    // Only run once.
    if (Foundation.Shadowbox.init["options"]) return;
    
    // Extend the default options with the options the caller wants.
    options = Foundation.extend(Foundation.Shadowbox.defaultOptions, options)
    Foundation.Shadowbox.init["options"] = options;
    
    // Load Shadowbox CSS.
    var link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");
    link.setAttribute("href", "/foundation/scripts/shadowbox/shadowbox.css");
    var someLinkTag = document.getElementsByTagName("link")[0];
    someLinkTag.parentNode.insertBefore(link, someLinkTag);
    
    document.write(
        "<script>" +
        "Shadowbox.init(Foundation.Shadowbox.init.options);" +
        "</script>"
    );
};

// ---------------------------------------------------------------------

window["Foundation"]["Shadowbox"] = {};
window["Foundation"]["Shadowbox"]["init"] = Foundation.Shadowbox.init;
